// AYA PRO — Compte & Banque Pro : le compte bancaire adossé aux commerçants (Bridge Bank)
// déménagé depuis Mon Compte (lutte contre la précarité bancaire).
import { useNavigate } from "react-router-dom";
import ProShell from "@/pro/ProShell";
import MonComptePro from "@/components/MonComptePro";
import ProStickyCTA from "@/components/ProStickyCTA";
import useUserId from "@/hooks/useUserId";

export default function ProComptePage() {
  const navigate = useNavigate();
  const userId = useUserId();
  return (
    <ProShell>
      <button className="pro-back" data-testid="pro-compte-back-btn" onClick={() => navigate("/pro")}>
        ← Retour à l'accueil PRO
      </button>
      <div className="pro-hero">
        <h1 data-testid="pro-compte-title">🏦 Compte & Banque <span>Pro</span></h1>
        <p>Votre compte bancaire professionnel, mini-site, leads et réservations.</p>
      </div>
      <div data-testid="pro-compte-content">
        <MonComptePro />
      </div>
      {/* 2026-10 — CTA "Boost ta visibilité" déplacé depuis Mon Compte (perso) vers l'espace Pro. */}
      <ProStickyCTA userId={userId} />
    </ProShell>
  );
}
